import React from "react";
import PropTypes from "prop-types";
import MDButton from "../MDButton";
import { DownloadOutlined } from "@ant-design/icons";

const ExportToExcel = ({ data, columns, fileName }) => {
  const exportToCSV = () => {
    // Extracting column titles from the columns array
    const headerRow = ["Sr. No.", ...columns.map((column) => column.title)].join(",");

    // Extracting data values from the data array
    const dataRows = data.map((row, index) => {
      const serialNumber = index + 1;
      const rowData = [serialNumber, ...columns.map((column) => {
        // Check if the column is the description column
        if (column.dataIndex === 'Plant_Desc' || column.dataIndex === 'Plant_Uses') {
          // Replace any commas within the description with another character (e.g., semicolon)
          return row[column.dataIndex].replace(/,/g, ';');
        } else {
          return row[column.dataIndex];
        }
      })];
      return rowData.join(",");
    });
    // const dataRows = data.map((row) => columns.map((column) => row[column.dataIndex]).join(","));
    const csvContent = "data:text/csv;charset=utf-8," + headerRow + "\n" + dataRows.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);

    link.click();
  };

  return (
    <MDButton onClick={exportToCSV} variant="contained" icon={<DownloadOutlined />}>
      Export CSV
    </MDButton>
  );
};

ExportToExcel.propTypes = {
  data: PropTypes.array.isRequired,
  fileName: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
};

export default ExportToExcel;
